import { Target } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

const NoMaskSelectedCard = () => (
  <div className="lg:col-span-2">
    <Card>
      <CardContent className="py-12">
        <div className="text-center space-y-4">
          <div className="w-16 h-16 mx-auto bg-gray-100 rounded-full flex items-center justify-center">
            <Target className="w-8 h-8 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900">Select a Mask to Begin</h3>
          <p className="text-sm text-gray-600 max-w-md mx-auto">
            Choose a mask from the selection above to view the workflow steps and track progress
            through the fabrication process.
          </p>
        </div>
      </CardContent>
    </Card>
  </div>
);

export default NoMaskSelectedCard;
